var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHniSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_913_835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8482 15.1295L11.7172 11.0646C12.799 9.8893 13.4637 8.33495 13.4637 6.62455C13.4632 2.96568 10.4494 0 6.73158 0C3.0137 0 0 2.96568 0 6.62455C0 10.2834 3.0137 13.2491 6.73158 13.2491C8.33795 13.2491 9.81129 12.6935 10.9686 11.7697L15.1155 15.8507C15.3176 16.0498 15.6457 16.0498 15.8477 15.8507C16.0502 15.6517 16.0502 15.3286 15.8482 15.1295ZM6.73158 12.2299C3.58585 12.2299 1.03575 9.72029 1.03575 6.62455C1.03575 3.52881 3.58585 1.01923 6.73158 1.01923C9.87733 1.01923 12.4274 3.52881 12.4274 6.62455C12.4274 9.72029 9.87733 12.2299 6.73158 12.2299Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_913_835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHniSearch);
export default __webpack_public_path__ + "static/media/hniSearch.95f35a3d2a43d2981cf6aa04ae38e780.svg";
export { ForwardRef as ReactComponent };